module.exports = __webpack_public_path__ + "images/account.ea6d8b.svg";